import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import PagesModule from 'modules/pages';
import pageLayout from 'HOC/pageLayout';
import PageTitle from 'components/PageTitle';
import Preloader from 'components/Preloader';


class Privacy extends Component {
  componentDidMount = () => {
    const { data, onFetch } = this.props;

    if (!data) onFetch();
  }

  render() {
    const { data } = this.props;

    const seo = data?.seo;
    const content = data?.content;
    const title = (content?.header?.bannerText || 'Privacy');

    if (!data) return (
      <div className="page-body">
        <Preloader />
      </div>
    );

    return (
      <>
        {
          seo &&
          <Helmet>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords}></meta>
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
          </Helmet>
        }
        <div className="page-body">
          <PageTitle title={title} align="center" />

          <div className="content-container">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  <div
                    className="content-block"
                    dangerouslySetInnerHTML={{
                      __html: content?.data
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default compose(
  pageLayout(),
  connect(state => ({
    data: state.pages.privacy
  }), dispatch => ({
    onFetch: () => dispatch(PagesModule.fetch('privacy'))
  })),
)(Privacy);